import { Radio } from 'antd';
import 'antd/es/radio/style/index';
import './index.less';

export default Radio;
